import { Injectable } from '@angular/core';

import { KeyValueUserRolesType } from '@models/common';
import { GridViewModel, SearchViewModel } from '@models/module/grid';
import { AssignContractUserRole } from '@module-instance/assignments/assign-users-dialog/assign-users-dialog.model';
import {
  Assignments,
  SyncRolePositionModel,
  SyncUsersAndRolesModel,
} from '@module-instance/assignments/common/assignments.model';
import { SyncPrimaryUsersModel } from '@module-instance/assignments/primary-users-dialog/primary-user-dialog.model';
import { HttpService } from '@shared/services';

@Injectable({ providedIn: 'root' })
export class AssignmentsService {
  constructor(private httpService: HttpService) {}

  getAssignments(searchModel: SearchViewModel, entityInstanceId: number) {
    const params = this.httpService.buildHttpParams({ entityInstanceId });
    return this.httpService.post<GridViewModel<Assignments[]>>(`_api/Role/GetUsers`, searchModel, {
      httpOptions: { params },
      useLoader: false,
    });
  }

  syncAssignments(syncModel: SyncUsersAndRolesModel) {
    return this.httpService.put<void>(`_api/Role/SyncUsersAndRolesForContract`, syncModel, { useLoader: false });
  }

  getUsers(contractId: number, getDisabled: boolean, excludeUserIds: number[]) {
    const params = this.httpService.buildHttpParams({ contractId, getDisabled });
    return this.httpService.post<KeyValueUserRolesType<number, string>[]>(`_api/User/DictWithExclude`, excludeUserIds, {
      httpOptions: { params },
      useLoader: false,
    });
  }

  asignUsers(userIds: AssignContractUserRole) {
    return this.httpService.put<void>(`_api/Role/AssignContractUserRole`, userIds, { useLoader: false });
  }

  savePrimaryUsers(primaries: SyncPrimaryUsersModel) {
    return this.httpService.put<void>(`_api/Role/SyncContractPrimary`, primaries, { useLoader: false });
  }

  syncRolePosition(positions: SyncRolePositionModel) {
    return this.httpService.put<void>(`_api/Contracts/SyncRolePositions`, positions, { useLoader: false });
  }
}
